export default {
    CustomerList: {
        ChooseCustomer: 'Seleccionar cliente',
    },

    Customer: {
        SafesOnline: 'Cajas fuertes en lÌnea',
        CurrentBalance: 'Saldo actual',
        DailySales: 'Ventas diarias',
        ActiveWarnings: 'Advertencias activas',
        Of: 'DE',
        In: 'IN',
        Branches: 'Delegaciones'
    },

    Branch: {
        ExportTransactions: "Exportar transacciones",
        ManageOperators: "Administrar operadores",
        ShowOnMap: "Mostrar en mapa",
        CurrentBalance: "Saldo actual",
        DailySales: 'Ventas diarias',
        MainCurrency: 'Moneda Principal',
        TransactionDays: 'DÌas de Transacciones'
    },

    BranchList: {
        Name: 'Nombre',
        Status: 'Estado',
        BalanceAmount: 'Saldo',
        BalanceCurrency: 'Divisa de saldo',
        LastBalance: 'Actualizado',
        Branches: 'Sucursales',
    },

    BranchListFilter: {
        Branches: 'Delegaciones',
        SearchCriteria: 'Buscar DelegaciÛn...',
    },

    Chart: {
        Sales: 'Ventas',
        Pickup: 'Recogida',
        Balance: 'Saldo',
        Difference: 'Diferencia',
        Confirmed: 'Confirmada',
        DepositsAndPickups: 'DepÛsitos y recogidas',
        NoDataAvailable: 'No hay datos disponibles',
        SafebagBalance: 'Balance de Bolsa de depÛsito',
        RecyclableBalance: 'Balance de reciclado',
        ManualDepositBalance: 'Balance de depÛsitos manuales',
        OverflowBalance: 'Balance de exceso'
    },

    ChartDenominations: {
        Deposited: 'Depositado',
        Recyclable: 'Reciclabe',
        Denominations: 'Denominaciones',
        NoDataAvailable: 'No hay datos disponibles'
    },

    ChartTransactionDay: {
        ProcessedSales: 'Ventas procesadas',
        UnprocessedSales: 'ventas no procesadas',
        SalesOut: 'Ventas Externas',
        SalesPerHour: 'Ventas por hora'
    },

    CustomerHeader: {
        ShowOnMap: 'Mostrar en mapa',
        Branches: 'Sucursales',
        Branch: 'Sucursal',
        ExportTransactions: "Exportar transacciones",
    },

    DeviceStatus: {
        AllOk: 'Todo Ok',
    },

    DeviceStatusList: {
        Safes: 'Cajas fuertes',
    },

    ExportForm: {
        ExportTransactions: 'Exportar transacciones',
        Cancel: 'Cancelar',
        Export: 'Exportar',
        FromDate: 'Desde la fecha',
        Time: 'Hora',
        EndDate: 'Fecha final'
    },

    ForgotPasswordForm: {
        ForgotHeader: 'øOlvidÛ su contraseÒa?',
        ForgotText: 'Por favor introduzca su correo electrÛnico a continuaciÛn y haga clic en el botÛn. Recibir·s un correo con m·s instrucciones.',
        LoginLink: 'Volver al inicio de sesiÛn',
        EmailAddress: 'DirecciÛn de correo electrÛnico',
        Submit: 'Enviar correo electrÛnico',
        ErrorMessage: 'No hemos podido enviar su solicitud al servidor'
    },

    LoginPage: {
        LoginHeader: 'Bienvenido',
        LoginText: 'Inicie sesiÛn con su correo electrÛnico y contraseÒa',
        LoginForgot: 'øOlvidÛ su contraseÒa?',
        Username: 'Correo ElectrÛnico',
        Password: 'CONTRASE—A',
        Login: 'Inicio de sesiÛn'
    },

    ResetPasswordPage: {
        ResetHeader: 'Restablecer contraseÒa',
        ResetText: 'Introduzca su nueva contraseÒa'
    },

    Drawer: {
        Dashboard: 'Panel de control',
        SwitchCustomer: 'Cambiar cliente',
        MyProfile: 'Mi perfil',
        Logout: 'Cerrar sesiÛn'
    },

    OperatorForm: {
        UserId: 'Id de usuario',
        FirstName: 'Nombre',
        LastName: 'Apellido',
        Pin: 'Pin',
        Save: 'Guardar',
        Delete: 'Eliminar',
        Operator: 'Operador',
    },

    OperatorList: {
        AddOperator: 'Agregar operador',
        Operators: 'Operadores',
        Name: 'Nombre'
    },

    Profile: {
        Profile: 'Perfil',
        Name: 'Nombre',
        Language: 'Idioma',
        Password: 'ContraseÒa',
        ConfirmPassword: 'Confirmar contraseÒa',
        Update: 'Actualizar'
    },

    ResetPasswordForm: {
        NewPassword: 'Nueva contraseÒa',
        ConfirmPassword: 'Confirmar contraseÒa',
        Submit: 'Enviar'
    },

    InviteUserForm: {
        InviteHeader: 'Bienvenido',
        InviteText: 'Por favor rellene sus datos de perfil y pulse guardar para poder iniciar la sesiÛn.í',
        Name: 'Nombre',
        Language: 'Idioma',
        NewPassword: 'Nueva ContraseÒa',
        ConfirmPassword: 'Confirme la ContraseÒa',
        Submit: 'Guardar'
    },

    TransactionList: {
        Type: 'Tipo',
        Operator: 'Operador',
        When: 'Cuando',
        Amount: 'Importe',
        Currency: 'Divisa',
        Transactions: 'Transacciones',
        Device: 'Dispositivo',
        SalesDay: 'DÌa de venta',
        HoverDeposit: 'Ingresos de venta',
        HoverSalesIn: 'Ingresos de venta',
        HoverSalesOut: 'Salidas de caja',
        HoverManualDeposit: 'Deposito Manual',
        HoverCollection: 'Recogida',
        HoverCollectionNotes: 'Recogida de billetes',
        HoverCollectionCoins: 'Recogida de Monedas',
        HoverCollectionEnvelope: 'Recogida de Depositos manuales',
        HoverCollectionOK: 'Recogida Confirmada',
        HoverCollectionNotesOK: 'Recogida de billetes confirmada',
        HoverCollectionCoinsOK: 'Recogida de moneda confirmada',
        HoverCollectionEnvelopeOK: 'Recogida de depositos manuales confirmada',
        HoverCollectionNOK: 'Diferencia en la recogida',
        HoverCollectionNotesNOK: 'Diferencia en la recogida de billetes',
        HoverCollectionCoinsNOK: 'Diferencia en la recogida de moneda',
        HoverCollectionEnvelopeNOK: 'Diferencia en la recogida de repositos manuales',
        HoverDrain: 'Retirar',
        HoverRefill: 'Recarga',
        HoverExchange: 'Cambio',
        HoverExchangeIn: 'Entrada para cambio',
        HoverExchangeOut: 'Cambio dispensado ',
        HoverCounterfeit: 'Falso',
        HoverInternal: 'TransacciÛn Interna',
        HoverNOP: 'Sin Operaciones'
    },

    TransactionDayList: {
        Date: "Fecha",
        Sales: "Ventas",
        Pickup: "Recogida",
        Balance: "Cuadre",
        TransactionDays: "Fechas de Transacciones"
    },

    TransactionDay: {
        Date: "Fecha",
        Sales: "Ventas",
        Pickup: "Recogida",
        Balance: "Cuadre",
        TransactionDays: "Fechas de Transacciones",
        ExportTransactions: 'Exportar transacciones',
    },

    TransactionDatePicker: {
        Date: 'Fecha'
    }
};


// WEBPACK FOOTER //
// ./src/lib/i18n/es.js